import {UUID} from '../../../shared/types/uuid.type';
import {createAction, props} from '@ngrx/store';

const prefix = '[StopManyDVRs] ';

export const stopManyDvr = createAction(
  `${prefix} Stop Many DVRs`,
  props<{ ids: UUID[] }>()
);

export const stopManyDvrSuccess = createAction(
  `${prefix} Stop Many DVRs Success`,
  props<{ ids: UUID[] }>()
);

export const stopManyDvrFailure = createAction(
  `${prefix} Stop Many DVRs Failure`,
  props<{ error: any }>()
);

export const clearStopManyDvrState = createAction(
  `${prefix} Clear Stop Many DVRs State`
);
